import { ThemeProvider } from '@mui/material/styles'
import PropTypes from 'prop-types'
import React from 'react'

import Colors from '@components/branding/colors'
import theme from '@components/branding/theme'
import { Box, Stack } from '@components/ui'

import BasicHeader from './basic-header'
import Footer from './footer'
import Header from './header'

const Layout = ({ children, basicHeader }) => (
  <ThemeProvider theme={theme}>
    <Stack bgcolor={Colors.background.color} minHeight={window.innerHeight}>
      {basicHeader ? <BasicHeader /> : <Header />}
      <Box
        component="main"
        flex={1}
        padding={{ xs: 2, sm: 6 }}
        maxWidth={1600}
        width={{
          sm: '100%',
          md: '95%',
        }}
        marginX="auto"
      >
        {children}
      </Box>
      <Footer />
    </Stack>
  </ThemeProvider>
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  basicHeader: PropTypes.bool,
}

Layout.defaultProps = {
  basicHeader: false,
}
export default Layout
